(() => {
  const pendingColors = new Map();
  function applyColors(drawer) {
    const group = drawer.querySelector('[data-collection-url]');
    if (!group) return;
    const collection = group.dataset.collectionUrl;
    const url = new URL(location.href);
    const oldTags = url.pathname.slice(collection.length + 1).split('+').filter(t => t && !t.startsWith('lens-color-') && !t.startsWith('frame-color-'));
    const chosen = [...new Map([...drawer.querySelectorAll('[data-bv-color-filter]:checked')]
      .filter(input => input.value)
      .map(input => [input.dataset.bvNativeTagValue || input.value, input])).values()];
    const filterForm = document.querySelector('[data-bv-tag-filter-ready]');
    const storefrontTagFilteringReady = filterForm?.dataset.bvTagFilterReady === 'true';
    const tagFilterOperator = (filterForm?.dataset.bvTagFilterOperator || 'UNAVAILABLE').toUpperCase();
    const existingNotice = drawer.querySelector('[data-bv-tag-filter-notice]');
    if (existingNotice) existingNotice.remove();
    if (chosen.length > 1 && (!storefrontTagFilteringReady || tagFilterOperator !== 'OR')) {
      const notice = document.createElement('p');
      notice.dataset.bvTagFilterNotice = 'true';
      notice.setAttribute('role','alert');
      const lang = (document.documentElement.lang || 'en').slice(0,2).toLowerCase();
      const isAnd = storefrontTagFilteringReady && tagFilterOperator === 'AND';
      notice.textContent = lang === 'fr'
        ? isAnd
          ? 'Le filtre « Étiquettes de produit » est configuré sur ET. Dans Shopify Search & Discovery > Filtres > Étiquettes de produit, sélectionnez Logique : OU.'
          : 'Pour choisir plusieurs couleurs (OU), activez le filtre « Étiquettes de produit » avec la logique OU dans Shopify Search & Discovery.'
        : lang === 'ar'
          ? isAnd
            ? 'فلتر علامات المنتجات مضبوط على AND. ادخل إلى Shopify Search & Discovery، ثم Filters > Product tags، واختر Logic: OR.'
            : 'لاختيار عدة ألوان، فعّل فلتر علامات المنتجات بإعداد Logic: OR في Shopify Search & Discovery.'
          : isAnd
            ? 'Product tags is set to AND. In Shopify Search & Discovery > Filters > Product tags, change Logic to OR.'
            : 'To select multiple colors, enable Product tags with Logic: OR in Shopify Search & Discovery.';
      notice.style.cssText = 'box-sizing:border-box;padding:12px;margin:8px 12px;background:#fff3e8;color:#111;font-size:12px;line-height:1.5;';
      (drawer.querySelector('.facets__drawer-actions') || group).prepend(notice);
      return;
    }
    // Preserve all other Shopify filter parameters and legacy non-color tag constraints.
    url.pathname = collection + (oldTags.length ? '/' + oldTags.join('+') : '');
    url.searchParams.delete('filter.p.tag');
    if (storefrontTagFilteringReady) {
      // Shopify supports repeated parameters for multiple OR values. Use the
      // canonical filter_value.value emitted by its Liquid filter object.
      chosen.forEach(input => {
        url.searchParams.append('filter.p.tag', input.dataset.bvNativeTagValue || input.value);
      });
    } else if (chosen.length === 1) {
      // One legacy tag remains usable even without Search & Discovery.
      url.pathname += '/' + chosen[0].dataset.bvTagHandle;
    }
    ['page','bv-lens-color','bv-frame-color'].forEach(key=>url.searchParams.delete(key));
    location.assign(url);
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-bv-language]')) event.target.form.requestSubmit();
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-bv-sort]')) {
      const url = new URL(location.href);url.searchParams.set('sort_by',input.value);url.searchParams.delete('page');location.assign(url);
    }
    if (!input.matches('[data-bv-color-filter]')) return;
    if (input.matches('[data-bv-taxonomy-child]')) {
      // Hierarchical v3 owns syncing repeated colors between overlapping families.
      // Do not suppress its input change event or depend on a flat .bv-color-options.
      pendingColors.set(input.name, new Set([...document.querySelectorAll('#filters-drawer [data-bv-color-filter]:checked')]
        .filter(x => x.name === input.name).map(x => x.value)));
      return;
    }
    event.stopImmediatePropagation();

    const group = input.closest('.bv-color-options');
    if (!group) return;
    if (input.value === '' && input.checked) {
      group.querySelectorAll('[data-bv-color-filter]').forEach(option => { option.checked = option.value === ''; });
    } else {
      const selected = [...group.querySelectorAll('[data-bv-color-filter]:checked')].filter(option => option.value !== '');
      const allColors = group.querySelector('[data-bv-color-filter][value=""]');
      if (allColors) allColors.checked = selected.length === 0;
    }
    pendingColors.set(input.name,new Set([...group.querySelectorAll('[data-bv-color-filter]:checked')].filter(option => option.value).map(option => option.value)));
  }, true);
  document.addEventListener('click', event => {
    const sortChoice = event.target.closest('[data-bv-sort-option]');
    if (sortChoice) {
      event.preventDefault();
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sortChoice.dataset.bvSortOption);
      url.searchParams.delete('page');
      location.assign(url);
      return;
    }
    if (event.target.closest('[data-bv-open-filters]')) document.querySelector('[on\\:click="#filters-drawer/open"]')?.click();
    if (!event.target.closest('.bv-toolbar-sort-menu')) {
      document.querySelectorAll('.bv-toolbar-sort-menu[open]').forEach(menu => { menu.open = false; });
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.bv-toolbar-sort-menu[open]').forEach(menu => { menu.open = false; });
    }
  });
  document.addEventListener('click', event => {
    const apply=event.target.closest('#filters-drawer .facets__see-results');
    if(apply && (pendingColors.size || document.querySelector('#filters-drawer [data-bv-taxonomy-child][data-bv-color-filter]'))){event.preventDefault();event.stopImmediatePropagation();applyColors(apply.closest('#filters-drawer'));}
    const clear=event.target.closest('#filters-drawer .facets__clear-all');
    if(clear && (pendingColors.size || document.querySelector('#filters-drawer [data-bv-taxonomy-child][data-bv-color-filter]') || /(lens-color-|frame-color-)/.test(location.pathname) || new URL(location.href).searchParams.has('filter.p.tag'))){
      const group=clear.closest('#filters-drawer').querySelector('[data-collection-url]');
      if(group){event.preventDefault();event.stopImmediatePropagation();const url=new URL(group.dataset.collectionUrl,location.origin);const sort=new URL(location.href).searchParams.get('sort_by');if(sort)url.searchParams.set('sort_by',sort);location.assign(url);}
    }
  },true);
  const topButton = document.querySelector('[data-bv-back-top]');
  if (topButton) {
    const update = () => { topButton.hidden = window.scrollY < Math.max(450, innerHeight * .7); };
    window.addEventListener('scroll', update, {passive:true}); update();
    topButton.addEventListener('click', () => {
      window.scrollTo({top:0, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    });
  }
  function enhance(root = document) {
    const sort = new URL(location.href).searchParams.get('sort_by');
    root.querySelectorAll('results-list').forEach(host => {
      // The stock/best-selling sorter owns smart cards on these pages.
      // Avoid inserting temporary cards before its grid.replaceChildren().
      const stockSort = new URL(location.href).searchParams.get('sort_by');
      const stockSmart = host.dataset.bvPromoSmart === 'true' &&
          host.hasAttribute('data-bv-stock-order') &&
          (!stockSort || stockSort === 'best-selling');
      // Wait until the stock-first sorter has committed its final grid.
      if (stockSmart && host.dataset.bvPromoReady !== 'true' &&
          host.dataset.bvPromoFallback !== 'true') return;
      if (host.hasAttribute('data-bv-order-loading')) return;
      const grid = host.querySelector('.product-grid'); if (!grid) return;
      // Theme blocks are rendered by {% content_for 'blocks' %}, not section.blocks.
      // Keep the original, working template cloner for both manual and smart modes.
      const promoEntries = [...host.querySelectorAll('[data-bv-promo-templates] template')]
        .map((template, index) => {
          const promo = template.content.firstElementChild;
          const position = Number(promo?.dataset.afterProduct);
          return {promo, index, position, target: promo?.dataset.bvPromoTarget || ''};
        })
        .filter(entry => entry.promo?.dataset.bvPromoId &&
          Number.isSafeInteger(entry.position) && entry.position > 0);
      let promoPlacements = promoEntries;
      if (host.dataset.bvPromoSmart === 'true' && promoEntries.length > 0) {
        const priorityByCollection = {
          '326293487801': ['326293487801','ronaldo-product','490643390649','508720545977','508589736121','507788820665','490642899129','celebrity-guide'],
          '507788820665': ['507788820665','508720545977','508589736121','326293487801','490643390649','490642899129','ronaldo-product','celebrity-guide'],
          '508720545977': ['508720545977','326293487801','507788820665','508589736121','490643390649','490642899129','ronaldo-product','celebrity-guide'],
          '490642899129': ['490642899129','326293487801','507788820665','ronaldo-product','508589736121','490643390649','508720545977','celebrity-guide'],
          '490643390649': ['490643390649','326293487801','ronaldo-product','508720545977','507788820665','508589736121','490642899129','celebrity-guide'],
          '508589736121': ['508589736121','326293487801','507788820665','508720545977','490643390649','ronaldo-product','490642899129','celebrity-guide']
        };
        const defaultPriority = ['490642899129','326293487801','508589736121','508720545977','507788820665','490643390649','celebrity-guide','ronaldo-product'];
        const priority = priorityByCollection[host.dataset.bvPromoCollectionId] || defaultPriority;
        const rank = entry => {
          const i = priority.indexOf(entry.target);
          return i < 0 ? priority.length : i;
        };
        const ordered = [...promoEntries].sort((a,b) =>
          rank(a) - rank(b) || a.position - b.position || a.index - b.index);
        const originalSlots = promoEntries.map(entry => entry.position).sort((a,b) => a - b);
        const maxSlot = originalSlots[originalSlots.length - 1];
        const count = Number(host.dataset.bvPromoTotal);
        promoPlacements = ordered.map((entry, i) => {
          const originalSlot = originalSlots[i];
          const adjusted = Number.isSafeInteger(count) && count > 0 && count < maxSlot
            ? Math.max(1, Math.floor(originalSlot * count / maxSlot))
            : originalSlot;
          return {...entry, position: adjusted};
        });
      }
      // Respect absolute product positions across infinite-scroll pages.
      // Group promotions at the same position to preserve their smart order.
      const promoGroups = new Map();
      for (const entry of promoPlacements) {
        const product = grid.querySelector(':scope > li[data-product-position="' + entry.position + '"]');
        if (!product) continue;
        const exists = [...grid.querySelectorAll(':scope > .bv-collection-promo')]
          .some(item => item.dataset.bvPromoId === entry.promo.dataset.bvPromoId);
        if (exists && !stockSmart) continue;
        const cards = promoGroups.get(product) || [];
        cards.push(entry.promo.cloneNode(true));
        promoGroups.set(product, cards);
      }
      if (stockSmart) {
        // Another Shopify renderer may replace or reorder grid children later.
        // Reconcile by stable promo IDs without reordering the products themselves.
        const mounted = [...grid.querySelectorAll(':scope > .bv-collection-promo')];
        const reused = new Set();
        for (const [product, cards] of promoGroups) {
          let cursor = product;
          for (const candidate of cards) {
            const matching = mounted.find(node =>
              !reused.has(node) && node.dataset.bvPromoId === candidate.dataset.bvPromoId);
            const promo = matching || candidate;
            if (cursor.nextElementSibling !== promo) cursor.after(promo);
            reused.add(promo);
            cursor = promo;
          }
        }
        for (const obsolete of mounted) if (!reused.has(obsolete)) obsolete.remove();
      } else {
        for (const [product, cards] of promoGroups) product.after(...cards);
      }
    });
    // Supports both the repeated-param format and older comma-separated links.
    const activeTags = new Set(new URL(location.href).searchParams
      .getAll('filter.p.tag').flatMap(value => value.split(',')).filter(Boolean));
    root.querySelectorAll('[data-bv-color-filter]').forEach(input => {
      if (input.matches('[data-bv-taxonomy-child]')) {
        const isSelected = activeTags.has(input.dataset.bvNativeTagValue || input.value) || activeTags.has(input.value);
        if (activeTags.size) input.checked = isSelected;
        return;
      }
      const chosen = pendingColors.get(input.name);
      if (chosen) {
        input.checked = input.value ? chosen.has(input.value) : chosen.size === 0;
      } else if (activeTags.size) {
        const options = input.closest('.bv-color-options');
        if (!options) return;
        const activeInGroup = [...options.querySelectorAll('[data-bv-color-filter]')].some(option =>
          option.value && (activeTags.has(option.dataset.bvNativeTagValue || option.value) || activeTags.has(option.value)));
        input.checked = input.value
          ? (activeTags.has(input.dataset.bvNativeTagValue || input.value) || activeTags.has(input.value))
          : !activeInGroup;
      }
    });
    const colors = {black:'#111',stealth:'#111',blue:'#1766c2',brown:'#8d5435',green:'#27934c',emerald:'#259b87',gold:'#c7a554',silver:'#b8bfc2',white:'#fff',transparent:'#fff',smoke:'#777',grey:'#888',gray:'#888',orange:'#ff8c00',yellow:'#e8c642',tea:'#b87738',purple:'#79507b',red:'#e22b28',pink:'#db8fa4',navy:'#172c4c',sea:'#6b98be',ice:'#b8d9e8',shell:'#805632',wood:'#805632',tan:'#b68a64',sunset:'#9b684b'};
    root.querySelectorAll('[data-bv-color]').forEach(node => {
      // Color Taxonomy v3.1 has accurate per-subcategory optical/finish swatches
      // in bv-color-taxonomy.css. Leave those styles alone. Legacy swatches keep fallback.
      if (node.closest('.bv-color-taxonomy')) {
        node.style.removeProperty('background-color');
        return;
      }
      const label = (node.dataset.bvColor || '').toLowerCase();
      const key = Object.keys(colors).find(name => label.includes(name));
      if (key) node.style.backgroundColor = colors[key];
      if (label.includes('anti blue')) node.style.backgroundColor = '#eef4f6';
    });
    root.querySelectorAll('.jdgm-prev-badge[data-number-of-reviews]').forEach(badge => {
      const count = Number(badge.getAttribute('data-number-of-reviews'));
      const label = badge.querySelector('.jdgm-prev-badge__text');
      if (!label || !Number.isSafeInteger(count) || count < 0) return;
      const lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
      let reviewText;
      if (lang === 'fr') {
        reviewText = `${count} avis`;
      } else if (lang === 'ar') {
        if (count === 1) reviewText = 'تقييم واحد (1)';
        else if (count === 2) reviewText = 'تقييمان (2)';
        else if (count % 100 >= 3 && count % 100 <= 10) reviewText = `${count} تقييمات`;
        else if (count % 100 >= 11 && count % 100 <= 99) reviewText = `${count} تقييمًا`;
        else reviewText = `${count} تقييم`;
      } else {
        reviewText = `${count} ${count === 1 ? 'review' : 'reviews'}`;
      }
      if (label.textContent.trim() !== reviewText) label.textContent = reviewText;
    });

  }

  // Align rating rows under the longest title/price in each visible collection grid row.
  // CSS provides a compact fallback; this only sets a per-row intrinsic height (no DOM moves).
  let bvCardAlignQueued = false;
  let bvAlignAll = false;
  const bvAlignAdded = new Set();
  function scheduleCollectionCardAlign(added) {
    if (Array.isArray(added)) added.forEach(item => bvAlignAdded.add(item));
    else bvAlignAll = true;
    if (bvCardAlignQueued) return;
    bvCardAlignQueued = true;
    requestAnimationFrame(() => {
      bvCardAlignQueued = false;
      document.querySelectorAll('#MainContent:is([data-template="collection"],[data-template="search"]) .product-grid').forEach(grid => {
        if (grid.getAttribute('product-grid-view') === 'zoom-out') return;
        let items;
        if (bvAlignAll) {
          items = [...grid.querySelectorAll(':scope > li[data-product-id]')];
        } else {
          items = [...bvAlignAdded].filter(item => item.parentElement === grid);
          // An appended batch can complete the previous batch's final row.
          // Measure that row too, without touching all earlier rows.
          const first = items[0];
          if (first) {
            const top = Math.round(first.getBoundingClientRect().top);
            for (let previous = first.previousElementSibling; previous; previous = previous.previousElementSibling) {
              if (Math.round(previous.getBoundingClientRect().top) !== top) break;
              if (previous.matches('li[data-product-id]')) items.push(previous);
            }
          }
        }
        items = items.filter(item => item.querySelector('.bv-card-layout'));
        // Clear previous measurements before reading natural title dimensions.
        for (const item of items) item.style.removeProperty('--bv-card-row-title-height');
        const rows = new Map();
        for (const item of items) {
          const card = item.querySelector('.bv-card-layout');
          // The product title link uses display:contents, so measuring the link
          // returns zero height in Safari and other browsers. Measure its real
          // .text-block box (including any Theme Editor padding) instead.
          const title = card.querySelector(':scope > a.contents > .text-block');
          const price = card.querySelector(':scope > product-price');
          const titleHeight = title?.getBoundingClientRect().height || 0;
          const priceHeight = price?.getBoundingClientRect().height || 0;
          const y = Math.round(item.getBoundingClientRect().top);
          const key = String(y);
          if (!rows.has(key)) rows.set(key, { items:[], height:0 });
          const row = rows.get(key);
          row.items.push(item);
          row.height = Math.max(row.height, titleHeight, priceHeight);
        }
        for (const row of rows.values()) {
          const height = Math.ceil(row.height);
          for (const item of row.items) item.style.setProperty('--bv-card-row-title-height', height + 'px');
        }
      });
      bvAlignAll = false;
      bvAlignAdded.clear();
    });
  }

  // Custom stock/best-selling ordering can replace the entire grid asynchronously.
  // Rebuild the existing smart promotions once the ordered cards have been committed.
  document.addEventListener('bv:catalog-order-updated', () => enhance());
  enhance();
  scheduleCollectionCardAlign();
  document.fonts?.ready.then(scheduleCollectionCardAlign);
  window.addEventListener('resize', scheduleCollectionCardAlign, {passive:true});
  // Restrict expensive work to added cards and replaced Collection controls.
  // Ignore internal slideshow changes to prevent all-card rescans on scroll.
  let queued = false;
  const addedCards = new Set();
  let refreshControls = false;
  let refreshPromoOrder = false;
  let realignCards = false;
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('li[data-product-id]')) {
          addedCards.add(node);
          realignCards = true;
        } else if (node.matches('[data-after-product]')) {
          refreshPromoOrder = true;
          realignCards = true;
        } else if (
          node.matches('results-list, .product-grid, .collection-wrapper, #filters-drawer, [data-bv-color-filter]') ||
          node.querySelector('.product-grid, li[data-product-id], [data-bv-color-filter]')
        ) {
          refreshControls = true;
          realignCards = true;
        } else if (node.matches('.jdgm-prev-badge')) {
          const card = node.closest('li[data-product-id]');
          if (card) addedCards.add(card);
        }
      }
    }
    if ((!refreshControls && !addedCards.size && !realignCards) || queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      const reorderedProducts = [...addedCards].some(card =>
        card.closest?.('results-list[data-bv-promo-smart="true"][data-bv-promo-ready="true"]'));
      if (refreshControls || refreshPromoOrder || reorderedProducts) enhance();
      else for (const card of addedCards) if (card.isConnected) enhance(card);
      if (realignCards) scheduleCollectionCardAlign(refreshControls ? undefined : [...addedCards]);
      addedCards.clear();
      refreshControls = false;
      refreshPromoOrder = false;
      realignCards = false;
    });
  }).observe(document.getElementById('MainContent') || document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load', () => { enhance();scheduleCollectionCardAlign(); });
})();


